import {PropType} from 'vue';
export function getHitColorProps() {
  return {
    /**
     * Color of the component
     */
    color: {
      type: String as PropType<
        | 'background'
        | 'header'
        | 'sidebar'
        | 'sidebar-selected'
        | 'panel'
        | 'panel-light'
        | 'table'
        | 'tag'
        | 'accent'
        | 'input'
        | 'button'
        | 'button-floating'
        | 'danger'
        | 'success'
        | 'warning'
      >,
      default: null,
      validator: function (value: string) {
        // The value must match one of these strings
        return (
          [
            'background',
            'header',
            'sidebar',
            'sidebar-selected',
            'panel',
            'panel-light',
            'table',
            'tag',
            'accent',
            'input',
            'button',
            'button-floating',
            'danger',
            'success',
            'warning',
          ].indexOf(value) !== -1
        );
      },
    },
  };
}
